import { render } from "./frequently-asked-questions.vue?vue&type=template&id=5b3aa816"
import script from "./frequently-asked-questions.vue?vue&type=script&lang=js"
export * from "./frequently-asked-questions.vue?vue&type=script&lang=js"

import "./frequently-asked-questions.vue?vue&type=style&index=0&id=5b3aa816&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__